export const NO_AD_SHOP_ITEM_ID = 133;
